import * as actionType from "../constants/action_types";

const initialState = {
  isSessionActive: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.LOGIN_SUCCESS:
      delete state.error
      return { ...state, ...action.payload, isSessionActive: true }
    case actionType.LOGOUT_SUCCESS:
      return initialState
    case actionType.LOGIN_ERROR:
      return { ...initialState, error: action.error }
    default:
      return state;
  }
};

export { userReducer };
